import { render, staticRenderFns } from "./CategoryProductListLoading.vue?vue&type=template&id=bb279f90&name=category-product-list-loading&"
import script from "./CategoryProductListLoading.vue?vue&type=script&lang=js&"
export * from "./CategoryProductListLoading.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProductListLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports